import { makeAutoObservable, runInAction } from 'mobx'
import { BrandsLoadingType } from './types'
import { handleAxiosError } from '~/shared/lib'
import { BrandsServices } from '~/shared/api/services/brands'
import {
  BrandByIdType,
  BrandResponse,
} from '~/shared/api/services/brands/types'

const INITIAL_FORM_BRAND = {
  active: false,
  alternateLinks: null,
  breadcrumbs: null,
  description: null,
  image: null,
  link: null,
  manufacturer_id: null,
  name: null,
  seo: null,
  slug: null,
  updated_at: null,
  sort_order: null,
  seo_title: null,
  seo_description: null,
  seo_keywords: null,
  icon: null,
}

export class BrandsStore {
  brands: BrandResponse[] = []

  loaders: BrandsLoadingType = {
    brands: false,
    loadMoreBrands: false,
  }

  formBrand: BrandByIdType = INITIAL_FORM_BRAND

  requestSettings = {
    limit: 20,
    offset: 0,
    isAllLoaded: false,
  }

  constructor() {
    makeAutoObservable(this)
  }

  activeLoader = (key: keyof BrandsLoadingType) => {
    this.loaders = { ...this.loaders, [key]: true }
  }

  closeLoader = (key: keyof BrandsLoadingType) => {
    this.loaders = { ...this.loaders, [key]: false }
  }

  setFormBrand = (key: keyof BrandByIdType, value: string | boolean | null) => {
    this.formBrand = { ...this.formBrand, [key]: value }
  }

  clearFormBrand = () => {
    this.formBrand = INITIAL_FORM_BRAND
  }

  getBrands = async (options?: { action?: 'loadMoreBrands' }) => {
    const { action } = options || {}
    if (action === 'loadMoreBrands' && this.requestSettings.isAllLoaded) return

    this.activeLoader(action || 'brands')

    try {
      const params = {
        limit: this.requestSettings.limit,
        offset: action !== 'loadMoreBrands' ? 0 : this.requestSettings.offset,
      }

      const { data } = await BrandsServices.getBrands({ params })

      if (action === 'loadMoreBrands') {
        runInAction(() => {
          this.brands = [...this.brands, ...data]
        })
      } else {
        runInAction(() => {
          this.brands = data
        })
      }
      runInAction(() => {
        this.requestSettings = {
          ...this.requestSettings,
          isAllLoaded: data.length < this.requestSettings.limit,
          offset:
            action === 'loadMoreBrands'
              ? this.requestSettings.offset + this.requestSettings.limit
              : 20,
        }
      })

      return data
    } catch (error) {
      const errorMessage = handleAxiosError(error)
      throw new Error(errorMessage)
    } finally {
      this.closeLoader(action || 'brands')
    }
  }

  setBrandsById = (data: BrandByIdType) => {
    this.formBrand = {
      ...INITIAL_FORM_BRAND,
      ...data,
    }
  }
}
